
export default function CommunityConnection() {
  return (
    <section id="community" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-1.5 bg-purple-50 rounded-full">
            <span className="text-sm text-purple-700 font-medium">커뮤니티 연결</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            후기 보고 → 공고 확인
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            따로 검색할 필요 없이 한 곳에서 모든 정보를 확인하세요
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {/* Community Card 1 */}
          <div className="bg-white rounded-3xl p-8 border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-400 to-purple-600 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white text-sm font-bold">A</span>
              </div>
              <div>
                <span className="text-sm font-bold text-gray-900">익명</span>
                <span className="text-xs text-gray-500 ml-2">5분 전</span>
              </div>
            </div>
            <p className="text-sm text-gray-700 leading-relaxed mb-6">
              강남 쪽에서 일하고 있는데 분위기 좋고 사장님도 친절하세요! 추천합니다 👍
            </p>
            <a 
              href="https://onnyjob.kr/login"
              className="block w-full py-3 bg-purple-600 text-white rounded-xl text-sm font-medium hover:bg-purple-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-center"
            >
              관련 공고 보기 →
            </a>
          </div>

          {/* Community Card 2 */}
          <div className="bg-white rounded-3xl p-8 border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-pink-400 to-pink-600 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white text-sm font-bold">B</span>
              </div>
              <div>
                <span className="text-sm font-bold text-gray-900">익명</span>
                <span className="text-xs text-gray-500 ml-2">12분 전</span>
              </div>
            </div>
            <p className="text-sm text-gray-700 leading-relaxed mb-6">
              밤에 일하면서 낮에는 자유롭게 시간 쓸 수 있어서 좋아요. 시급도 괜찮고 주변에 여자분들 많아서 안심되더라구요 ㅎㅎ 처음엔 걱정했는데 생각보다 괜찮네요!
            </p>
            <a 
              href="https://onnyjob.kr/login"
              className="block w-full py-3 bg-purple-600 text-white rounded-xl text-sm font-medium hover:bg-purple-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-center"
            >
              관련 공고 보기 →
            </a>
          </div>

          {/* Benefits Card */}
          <div className="bg-gradient-to-br from-purple-600 to-purple-700 rounded-3xl p-8 text-white flex flex-col justify-center">
            <h3 className="text-2xl font-bold mb-4">
              한 곳에서 비교하고 선택
            </h3>
            <p className="text-base text-white/90 mb-6 leading-relaxed">
              커뮤니티 정보 → 지역 알바 확인<br />
              끊기지 않는 구조로 편리하게
            </p>
            <div className="space-y-3">
              {[
                '실시간 후기와 공고 연결',
                '지역별 맞춤 정보',
                '안전한 여성 전용 커뮤니티'
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-5 h-5 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </div>
                  <span className="text-sm font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
